import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7167c0a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contact-form" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["placeholder"]
const _hoisted_4 = {
  key: 1,
  class: "message-error"
}
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = {
  key: 2,
  class: "message-error"
}
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = {
  key: 3,
  class: "message-error"
}
const _hoisted_9 = ["disabled"]

import {computed, ref, watch} from "vue";

type Rule = (value: string) => string|null


export default /*#__PURE__*/_defineComponent({
  __name: 'CContactForm',
  setup(__props) {

const validate = (value: string, rules: Array<Rule>): Array<string> => rules
    .map(rule => rule(value))
    .filter((error): error is string => error !== null)

const required: Rule = value => !!value ? null : 'validation-required'
const emailRule: Rule = value => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) ? null : 'validation-email'

const nameRules: Array<Rule> = [required]
const emailRules: Array<Rule> = [required, emailRule]
const textRules: Array<Rule> = [required]

const isLoading = ref(false)

const message = ref<string|null>(null)
const is_error = ref(false)

const name = ref('')
const nameErrors = ref<Array<string>>([])
const nameBlur = ref(false)
const email = ref('')
const emailErrors = ref<Array<string>>([])
const emailBlur = ref(false)
const text = ref('')
const textErrors = ref<Array<string>>([])
const textBlur = ref(false)

const isValid = computed(() =>
    nameErrors.value.length == 0 &&
    emailErrors.value.length == 0 &&
    textErrors.value.length == 0
)

nameErrors.value = validate(name.value, nameRules)
emailErrors.value = validate(email.value, emailRules)
textErrors.value = validate(text.value, textRules)
watch(name, () => nameErrors.value = validate(name.value, nameRules))
watch(email, () => emailErrors.value = validate(email.value, emailRules))
watch(text, () => textErrors.value = validate(text.value, textRules))

const handle = () => {
  if (isValid.value) {
    isLoading.value = true
    setTimeout(() => isLoading.value = false, 1500)
    message.value = null
    fetch('/api/messages', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        name: name.value,
        email: email.value,
        text: text.value
      })
    })
        .then(() => message.value = 'contact-success')
        .catch(() => {
          message.value = 'contact-error'
          is_error.value = true
        })
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (message.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["contact-form__message", { 'contact-form__message--error': is_error.value }]),
          innerHTML: _ctx.$t(message.value)
        }, null, 10, _hoisted_2))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("input", {
      type: "text",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
      placeholder: _ctx.$t('contact-form-name'),
      class: "contact-input",
      onBlur: _cache[1] || (_cache[1] = () => nameBlur.value = true)
    }, null, 40, _hoisted_3), [
      [_vModelText, name.value]
    ]),
    (nameErrors.value.length !== 0 && nameBlur.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.$t(nameErrors.value[0], { attribute: _ctx.$t('contact-form-name') })), 1))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("input", {
      type: "text",
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((email).value = $event)),
      placeholder: _ctx.$t('contact-form-email'),
      class: "contact-input",
      onBlur: _cache[3] || (_cache[3] = () => emailBlur.value = true)
    }, null, 40, _hoisted_5), [
      [_vModelText, email.value]
    ]),
    (emailErrors.value.length !== 0 && emailBlur.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.$t(emailErrors.value[0], { attribute: _ctx.$t('contact-form-email') })), 1))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("textarea", {
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((text).value = $event)),
      placeholder: _ctx.$t('contact-form-text'),
      class: "contact-input",
      rows: "4",
      onBlur: _cache[5] || (_cache[5] = () => textBlur.value = true)
    }, null, 40, _hoisted_7), [
      [_vModelText, text.value]
    ]),
    (textErrors.value.length !== 0 && textBlur.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.$t(textErrors.value[0], { attribute: _ctx.$t('contact-form-text') })), 1))
      : _createCommentVNode("", true),
    _createElementVNode("button", {
      type: "submit",
      class: "btn-submit",
      disabled: !isValid.value,
      onClick: handle
    }, _toDisplayString(isLoading.value ? '. . .' : _ctx.$t('contact-form-send')), 9, _hoisted_9)
  ]))
}
}

})